/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
// import { ASSETS_TABLE } from "../pages/ListedAssetsTable/graphql/listed-asset-table.query";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import {
    CHIP_LIST,
    PROV_DETAIL_INFO,
    PROV_STEP_TITLE,
    PROV_STEP_TITLE_CARD,
} from "./config/provenance-step-detail-view";
import { GET_PROV_STEP_CRED_DETAIL } from "../pages/ProvenancePage/graphql/get-provenance-step-detail.query";
import { NO_IMAGE } from "../assets/images";

const SERVICE_NAME = "provenance-step-detail.service";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class ProvenanceStepDetailViewService {
    name = SERVICE_NAME;
    private static instance: ProvenanceStepDetailViewService;

    private constructor() {
        this.report();
    }
    static getInstance() {
        if (!this.instance) {
            this.instance = new ProvenanceStepDetailViewService();
        }
        return this.instance;
    }

    _provenanceData = (data: any) => {
        let _provenance: any = {};

        const _getMeta = (metaData: any) => {
            let _meta : any[] = [];
            metaData && Array.isArray(metaData) && metaData.length > 0 && metaData.map((item: any, index: number) => {
                _meta.push({
                    key: item?.label,
                    value: item?.value
                })
            });
            return _meta;

        }

        return {
            //idx: _data?.credTxId,
            title: data?.ProvDetailInfo?.title,
            subtitle: data?.ProvStepTitle?.title,
            //serialNo: 'Rare #/1',
            // img: "https://dev-dc.vlinder.io/imgsrv/ipfs/QmTJFM4QPeN5aYc7uDZrHNdsA8oXQrn58fspRNNV3PmSYp",
            // // tag: 'DIAMOND',
            // // productCategory: 'collectibles',
            // // category: 'diamond',
            // price: [
            //     {
            //         type: "fiat",
            //         currency: "USD",
            //         locale: "en-US",
            //         amount: 1500.0,
            //     },
            //     {
            //         type: "crypto",
            //         currency: "ETH",
            //         amount: 0.5,
            //     },
            // ],
            // createdBy: {
            //     userName: "SWISS TIMING",
            //     userId: "swiss-timing",
            //     link: "/swiss-timing",
            //     authProofUrl:
            //         "https://gateway.pinata.cloud/ipfs/QmTJFM4QPeN5aYc7uDZrHNdsA8oXQrn58fspRNNV3PmSYp",
            // },
            meta: _getMeta(data?.ProvDetailInfo?.provInfoList),
            // // actions: [
            // //     {
            // //         key: "buyNowFiat",
            // //         title: "Buy in USD"
            // //     },
            // //     {
            // //         key: "buyNowCrypto",
            // //         title: " Buy in ETH"
            // //     }
            // // ],
            images: [
                {
                    original: NO_IMAGE,
                    thumbnail: NO_IMAGE,
                    thumbnailHeight: "70",
                    thumbnailClass: "image-thumb",
                },
            ],
        };
    };

    async provenanceStepDetailView(payload: any) {
        log.blue(SERVICE_NAME, ":", payload);
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_PROV_STEP_CRED_DETAIL,
                    variables: payload,
                    fetchPolicy: "network-only",
                });
                log.info(
                    `step data in service :`,
                    res?.data?.getProvenanceStepCred
                );
                let _data = res?.data?.getProvenanceStepCred?.data;
                if (_data) {
                    return {
                        provenanceData: this._provenanceData(
                            _data
                        ),
                        CHIP_LIST: _data?.ChipList,
                        PROV_DETAIL_INFO: _data?.ProvDetailInfo,
                        PROV_STEP_TITLE: _data?.ProvStepTitle,
                        PROV_STEP_TITLE_CARD: _data?.ProvStepTitleCard,
                        PROV_STEP_GEOJSON: _data?.provMapProps,
                    };
                }
                // return {

                // }
            }
            // let _data =  {CHIP_LIST,PROV_DETAIL_INFO,PROV_STEP_TITLE,PROV_STEP_TITLE_CARD }
            // return _data;
        } catch (err) {}
    }

    private report() {
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
        log?.info(SERVICE_NAME, "Module Report");
        log?.info(SERVICE_NAME, "⦿ Name: " + this.name);
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
    }
}
